<template>
  <div class="repair-wrap">
    <div class="nav-wrap" v-if="routePath === '/repair/list'">
      <div class="flex">
        <i class="iconfont icon-home1"></i>
        <router-link class="link" to="/">首页</router-link>
        <i class="el-icon-arrow-right"></i>
        <router-link class="link" :to="$route.path" replace
          ><span>信用修复公示</span></router-link
        >
      </div>
    </div>
    <div class="nav-wrap" v-else>
      <div class="flex">
        <i class="iconfont icon-home1"></i>
        <router-link class="link" to="/repair/country">信用服务</router-link>
        <i class="el-icon-arrow-right"></i>
        <router-link class="link" :to="$route.path" replace
          ><span>信用修复</span></router-link
        >
      </div>
    </div>
    <div class="tab_header flex flex-wrap flex-row-center">
      <router-link
        class="tab-list"
        :class="[routePath === '/repair/country' ? 'active' : '']"
        tag="a"
        to="/repair/country"
        ><span>在信用中国网站公示的行政处罚信用修复</span></router-link
      >
      <router-link
        class="tab-list"
        :class="[routePath === '/repair/province' ? 'active' : '']"
        tag="a"
        to="/repair/province"
        ><span>在信用中国（山东）网站公示的行政处罚信用修复</span></router-link
      >
      <!-- <router-link class="tab-list" :class="[routePath==='/repair/city'?'active':'']" tag="a" to="/repair/city"><span>仅在信用中国（山东泰安）网站公示的行政处罚信用修复</span></router-link>
			<router-link class="tab-list" :class="[routePath==='/repair/area'?'active':'']" tag="a" to="/repair/area"><span>仅在信用中国（山东肥城）网站公示的行政处罚信用修复</span></router-link> -->
    </div>

    <div class="repair-route">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {
    routePath({ $route }) {
      const { path } = $route
      return path
    },
  },
  watch: {},
}
</script>
<style lang="scss">
.repair-wrap {
  width: 100%;
  margin: 0 auto;
  padding: 0 0 30px;
  background-color: #fff;

  .nav-wrap {
    margin-bottom: 20px;
    .flex {
      // width: 1160px;
    }
  }

  .tab_header {
    box-shadow: 0 1px 3px rgb(0 0 0 / 10%);
    border-bottom: 1px solid #d2d3d4;
    overflow: hidden;
    padding: 30px;
    // width: 1160px;
    width: 1280px;
    margin: 0 auto;

    .tab-list {
      &:nth-child(2),
      &:nth-child(4) {
        margin-left: 15px;
      }
      &:nth-child(3),
      &:nth-child(4) {
        margin-top: 30px;
      }
      flex: 0 1 calc(50% - 15px);
      text-align: center;
      border: 1px solid #ddd;
      line-height: 50px;
      display: block;
      border-radius: 5px;
      &.active {
        border: 1px solid #0088d7;
        border-left: 4px solid #0088d7;
        box-shadow: 0 0 6px rgb(0 145 255 / 30%);
      }
      &:hover {
        border: 1px solid #0088d7;
        border-left: 4px solid #0088d7;
        box-shadow: 0 0 6px rgb(0 145 255 / 30%);
      }
    }
  }

  .repair-route {
    // width: 1160px;
    width: 1280px;
    margin: 26px auto 0;
  }
}
</style>
